/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Complete_Blocked_PendingInputs */

const en_task_complete_blocked_pending = /** @type {(inputs: Task_Complete_Blocked_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete the pending checklist items before finishing this task.`)
};

const pt_br2_task_complete_blocked_pending = /** @type {(inputs: Task_Complete_Blocked_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conclua os itens pendentes do checklist antes de finalizar esta atividade.`)
};

/**
* | output |
* | --- |
* | "Complete the pending checklist items before finishing this task." |
*
* @param {Task_Complete_Blocked_PendingInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_complete_blocked_pending = /** @type {((inputs?: Task_Complete_Blocked_PendingInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Complete_Blocked_PendingInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_complete_blocked_pending(inputs)
	return pt_br2_task_complete_blocked_pending(inputs)
});